import http from '../index.js'

export function getCheckList() {
  return http.post('hi/owner/check')
}
